import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";

export interface TelegramRecipient {
  user_id: string;
  username: string | null;
  email: string | null;
  is_seller: boolean;
}

export interface BroadcastResult {
  requested: number;
  sent: number;
  failed: { user_id: string; username: string | null; error: string }[];
}

export const getTelegramRecipients = (token: string) =>
  request(token).get<TelegramRecipient[]>(`${ENDPOINTS.NOTIFICATIONS}/users`);

export const sendTelegramBroadcast = (userIds: string[], message: string, token: string) =>
  request(token).post<BroadcastResult>(`${ENDPOINTS.NOTIFICATIONS}/send-notification`, { userIds, message });
